// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DashboardOptionsDropdown {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
  transition: 0.16s ease-in-out;
  visibility: hidden;
  opacity: 0;
}
.DashboardOptionsDropdown .DashboardOptionsDropdown-button {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(43, 43, 43, 0.3);
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.DashboardOptionsDropdown .DashboardOptionsDropdown-button:hover {
  background: rgba(208, 178, 255, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/components/DashboardCard/components/DashboardOptionsDropdown/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,6BAAA;EAEA,kBAAA;EACA,UAAA;AAAF;AAEE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iCAAA;EACA,kCAAA;UAAA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AAAJ;AAEI;EACE,oCAAA;AAAN","sourcesContent":[".DashboardOptionsDropdown {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 1;\n  transition: 0.16s ease-in-out;\n\n  visibility: hidden;\n  opacity: 0;\n\n  .DashboardOptionsDropdown-button {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    background: rgba(43, 43, 43, 0.3);\n    backdrop-filter: blur(5px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n\n    &:hover {\n      background: rgba(208, 178, 255, 0.30);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
